module.exports = __webpack_public_path__ + "static/media/grid_2x.a6827c85.png";